import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "@/authSessionClient";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<"loading" | "authed" | "anon">("loading");

  useEffect(() => {
    fetchAuthSession()
      .then((r) => r.json())
      .then((d: { authenticated?: boolean }) => {
        setStatus(d.authenticated ? "authed" : "anon");
      })
      .catch(() => setStatus("anon"));
  }, []);

  if (status === "loading") {
    return (
      <div className="min-h-screen text-white flex items-center justify-center bg-black">
        <p className="text-gray-400">Loading…</p>
      </div>
    );
  }

  if (status === "anon") {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
